export const ACTION_RESET = 'FETCH_VIDEOLIST_RESET';
export const ACTION_REQUEST = 'FETCH_VIDEOLIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_VIDEOLIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_VIDEOLIST_ERROR';
